import { __awaiter, __generator } from "tslib";
import { FileType } from '@office-start/document-types';
import { createForm, createFormFromTemplate, getFormsOptions, } from '@office-start/forms-service';
import { FormType } from '@office-start/forms-types';
import { launchUrlWrapper } from './launchUrlWrapper';
export function createNewForm(app, candidate, createOptions, area, template) {
    return __awaiter(this, void 0, void 0, function () {
        var formsOptions, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(app === FileType.Forms || app === FileType.FormsQuiz)) return [3 /*break*/, 6];
                    return [4 /*yield*/, getFormsOptions(createOptions.componentContext, createOptions.identity)];
                case 1:
                    formsOptions = _a.sent();
                    if (!formsOptions) {
                        return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
                    }
                    url = void 0;
                    if (!template) return [3 /*break*/, 3];
                    return [4 /*yield*/, createFormFromTemplate(formsOptions, template, FormType.Users, undefined)];
                case 2:
                    url = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    if (!candidate.newDocName) {
                        return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
                    }
                    url = createForm(formsOptions, app, candidate.newDocName, undefined, area);
                    _a.label = 4;
                case 4:
                    if (!url) {
                        return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
                    }
                    return [4 /*yield*/, launchUrlWrapper(url, createOptions.targetTab, createOptions.newDocLinkTarget)];
                case 5: return [2 /*return*/, _a.sent()];
                case 6: return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
            }
        });
    });
}
//# sourceMappingURL=createNewForm.js.map